import React, { Component } from 'react';

class Footer extends Component {



  render(){
  
  const postId = location.pathname.split("/")[1];
  
  
  
  console.log("pathname:", postId);
  
  
if (postId === 'uroonkoloji') {
    return (
   <div className="sticky-bottom mt-5 pb-5">
    
    <div className="col">
        <div className={`d-flex mb-3 footer-${location.pathname.split("/")[2]}`}>
                <div className="card mx-2" style={{width: "6rem"}}>
                  <a href="https://qr.recordatifocus.com/eligardkub" className="text-decoration-none text-black" target="_blank"><img alt="" src="/images/KUB-ELIGARD.png" className="img-fluid" /></a>
                  <div className="p-1" style={{backgroundColor: "#F09D8E"}}>
                    <a href="https://qr.recordatifocus.com/eligardkub" className="text-decoration-none text-black" target="_blank"><div className="text-center fw-bold">ELIGARD</div></a>
                  </div>
                </div>        
                <div className="card mx-2" style={{width: "6rem"}}>
                  <a href="https://qr.recordatifocus.com/hippurinkub" className="text-decoration-none text-black" target="_blank"><img alt="" src="/images/KUB-HIPPURIN.png" className="img-fluid" /></a>
                  <div className="p-1" style={{backgroundColor: "#52BDC7"}}>
                    <a href="https://qr.recordatifocus.com/hippurinkub" className="text-decoration-none text-black" target="_blank"><div className="text-center fw-bold">HİPPURİN</div></a>
                  </div>
                </div>
        </div>
		<p className={`pb-5 mx-3 fw-bold footer-link-${location.pathname.split("/")[2]}`}>www.recordati.com.tr</p>
   	</div>
    </div>
    );
}
  
  
if (postId === 'kardiyoloji') {
    return (
   <div className="sticky-bottom mt-5 pb-5">
    
    <div className="col">
        <div className={`d-flex mb-3 footer-${location.pathname.split("/")[2]}`}>
                <div className="card mx-2" style={{width: "7rem"}}>
                  <a href="https://qr.recordatifocus.com/colchicumkub" className="text-decoration-none text-black" target="_blank"><img alt="" src="/images/KUB-COLCHICUM.png" className="img-fluid" /></a>
                  <div className="p-1" style={{backgroundColor: "#F09D8E"}}>
                    <a href="https://qr.recordatifocus.com/colchicumkub" className="text-decoration-none text-black" target="_blank"><div className="text-center fw-bold">COLCHICUM</div></a>
                  </div>
                </div>        
        </div>
		<p className={`pb-5 mx-3 fw-bold footer-link-${location.pathname.split("/")[2]}`}>www.recordati.com.tr</p>
   	</div>
    </div>
    );
}

  

  
  
  
  }
}

export default Footer



// WEBPACK FOOTER //
// src/components/footer.jsx